import { Button } from 'grommet';
import styled from 'styled-components';

const Image = styled.img`
  width: 99px;
  height: 14px;
  margin: 7px 15px 7px 0;
  object-fit: contain;
`;

const LogOut = styled(Button)`
  width: 86px;
  height: 35px;
  font-size: 13px;
  background-color: transparent;
  color: #ffffff;
  font-weight: normal;
  cursor: pointer;
  border: 2px solid #ffffff;
  text-align: center;
  position: absolute;
  right: 0;
  left: 94%;
  top: 25;

  &:focus {
    background-color: #481ac3;
  }
  &:hover {
    background-color: #009cff;
  }
`;
export { Image, LogOut };
